import {
  Action,
  ActionType,
  IVoiceCallResponse,
} from "models/setting/voiceCall";
import createReducer from "redux/createReducer";

export interface VoiceCallReducerType {
  loading: boolean;
  error?: string;
  voiceCallResponse?: IVoiceCallResponse;
}

const defaultState: VoiceCallReducerType = {
  loading: false,
  error: undefined,
  voiceCallResponse: undefined,
};

export const voiceCallReducer = createReducer<VoiceCallReducerType>(
  defaultState,
  {
    [ActionType.VOICE_CALL](state: VoiceCallReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.VOICE_CALL_ERROR](
      state: VoiceCallReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.VOICE_CALL_SUCCESS](
      state: VoiceCallReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        voiceCallResponse: action.payload,
      };
    },

    [ActionType.VOICE_CALL_RESET](state: VoiceCallReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        voiceCallResponse: undefined,
      };
    },
  }
);
